import { formatDistance } from "../lib/track-utils";
import { useLang } from "../contexts/LanguageContext";

export default function PointsPanel({
    points,
    pois,
    onRemovePoint,
    onRemovePoi,
    onClose,
}) {
    const { t } = useLang();
    return (
        <div
            className="rf-card flex flex-col h-full overflow-hidden fade-up"
            style={{ width: 280 }}
            data-testid="points-panel"
        >
            <div className="flex items-center justify-between px-4 py-3 border-b border-[var(--border-soft)]">
                <h3 className="font-display font-semibold text-sm tracking-wide">
                    <i className="fa-solid fa-list-ol mr-2 text-[var(--accent)]"></i>
                    {t("trackPoints")}
                </h3>
                <button
                    onClick={onClose}
                    className="text-[var(--text-faint)] hover:text-[var(--accent)]"
                    data-testid="close-points-panel"
                >
                    <i className="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div className="flex-1 overflow-y-auto px-3 py-2 space-y-1.5">
                {points.length === 0 && pois.length === 0 && (
                    <div className="text-xs text-[var(--text-faint)] p-4 text-center">
                        {t("clickToStart")}
                    </div>
                )}
                {points.map((p, i) => (
                    <div
                        key={p.id}
                        className="flex items-center justify-between gap-2 px-3 py-2 rounded-lg hover:bg-[var(--bg-elev)] group"
                        data-testid={`point-row-${i}`}
                    >
                        <div className="flex items-center gap-2 min-w-0">
                            <span
                                className="font-mono-stat text-[10px] w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                                style={{
                                    background:
                                        i === 0
                                            ? "#4ade80"
                                            : i === points.length - 1
                                              ? "#ef4444"
                                              : "var(--accent)",
                                    color:
                                        i === points.length - 1 && i !== 0
                                            ? "#fff"
                                            : "#0b0d10",
                                }}
                            >
                                {i === 0
                                    ? "A"
                                    : i === points.length - 1
                                      ? "B"
                                      : i}
                            </span>
                            <div className="flex flex-col min-w-0">
                                <span className="font-mono-stat text-[11px] text-[var(--text-primary)] truncate">
                                    {p.lat.toFixed(4)}, {p.lng.toFixed(4)}
                                </span>
                                {typeof p.ele === "number" && (
                                    <span className="font-mono-stat text-[10px] text-[var(--text-faint)]">
                                        {Math.round(p.ele)} m
                                    </span>
                                )}
                            </div>
                        </div>
                        <button
                            onClick={() => onRemovePoint(p.id)}
                            className="opacity-0 group-hover:opacity-100 text-[var(--text-faint)] hover:text-[var(--danger)]"
                            data-testid={`row-remove-point-${i}`}
                        >
                            <i className="fa-solid fa-trash text-xs"></i>
                        </button>
                    </div>
                ))}
                {pois.length > 0 && (
                    <div className="pt-3 mt-3 border-t border-[var(--border-soft)]">
                        <div className="font-display text-[10px] uppercase tracking-wider text-[var(--text-faint)] mb-2 px-2">
                            <i className="fa-solid fa-bookmark mr-1"></i> {t("pois")}
                        </div>
                        {pois.map((p) => (
                            <div
                                key={p.id}
                                className="flex items-start gap-2 px-3 py-2 rounded-lg hover:bg-[var(--bg-elev)] group"
                                data-testid={`poi-row-${p.id}`}
                            >
                                <i className="fa-solid fa-location-dot text-[var(--accent)] mt-1"></i>
                                <div className="flex-1 min-w-0">
                                    <div className="text-xs font-medium text-[var(--text-primary)] truncate">
                                        {p.name || t("poi")}
                                    </div>
                                    {p.desc && (
                                        <div className="text-[10px] text-[var(--text-faint)] line-clamp-2">
                                            {p.desc}
                                        </div>
                                    )}
                                </div>
                                <button
                                    onClick={() => onRemovePoi(p.id)}
                                    className="opacity-0 group-hover:opacity-100 text-[var(--text-faint)] hover:text-[var(--danger)]"
                                    data-testid={`row-remove-poi-${p.id}`}
                                >
                                    <i className="fa-solid fa-trash text-xs"></i>
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
